export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    selected: {
      type: Boolean,
      requited: true,
    },
  },
  computed: {
    selectedModifier() {
      return {
        'state-button--selected': this.selected,
      };
    },
  },
  methods: {
    onClick() {
      this.$emit('click', this);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/export-history/state-button/state-button.js